export default __webpack_public_path__ + "static/media/play-icon.0e3e90a7.png";